import React from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import { BiEdit } from 'react-icons/bi';
import ThirdForm from '../thirdForm/view';
import { editThird } from '../../../usecases/thirds-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';

function EditThird({ data, onEdited = undefined, onClose = undefined, title = <BiEdit />, type = "action", ...props }) {

    function handleSubmit(dataToSend) {
        editThird(dataToSend.id, dataToSend).then(() => {
            dispatchCustomEvent("popup", { message: "Tercero actualizado con éxito" });
            if (onEdited) onEdited();
            dispatchCustomEvent("loading-btn", {});

            closeModal();
        }).catch(err => {
            const msg = err.response?.data?.message || "Error al editar tercero";
            dispatchCustomEvent("popup", { message: msg, type: "error" });
            dispatchCustomEvent("loading-btn", {});
        });
    }

    const closeModal = () => {
        const modalId = data.identification ? "edit-third-" + data.identification : "edit-third";
        dispatchCustomEvent("modal-close-" + modalId, {});
    };

    if (!data) return null;

    return (
        <div {...props}>
            <ModalBtn
                id={data.identification ? "edit-third-" + data.identification : "edit-third"}
                title={title}
                type={type}
                onClose={onClose}
                style={{ border: 'none', width: '100%', maxWidth: '850px', maxHeight: '90vh' }}
            >
                <ThirdForm
                    initialData={data}
                    onSubmit={handleSubmit}
                    loadingId="third-edit"
                    title="Editar Tercero"
                    submitLabel="Guardar Cambios"
                />
            </ModalBtn>
        </div>
    )
}

export default EditThird
